module.exports = __webpack_public_path__ + "img/news6.1e2395f6.png";